import React from 'react';
import CategoryLandingTemplate from '../../components/CategoryLandingTemplate';
import tecnalData from '../../data/tecnal';

const AlmacenamientoGranosPage = () => {
  return <CategoryLandingTemplate data={tecnalData['almacenamiento-de-granos']} />;
};

export default AlmacenamientoGranosPage;
